var map = {
	"./flag-FRANCE.svg": "fba5",
	"./flag-GERMANY.svg": "bc71",
	"./flag-NETHERLANDS.svg": "d84d",
	"./flag-POLAND.svg": "8ea0",
	"./flag-SPAIN.svg": "631f",
	"./flag-SWEDEN.svg": "5694",
	"./flag-UK.svg": "f9bf"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3bdd";